/**
 * Where a signed-in practitioner belongs when no particular destination was asked for.
 *
 * One constant rather than a literal at each redirect: 006 moved this from the contexts list to the
 * home page, and two of the three places that decide it were easy to miss.
 */
export const SIGNED_IN_LANDING = '/home';
